import { render, staticRenderFns } from "./ListItemCity.vue?vue&type=template&id=57b12ce8&"
import script from "./ListItemCity.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemCity.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b12ce8')) {
      api.createRecord('57b12ce8', component.options)
    } else {
      api.reload('57b12ce8', component.options)
    }
    module.hot.accept("./ListItemCity.vue?vue&type=template&id=57b12ce8&", function () {
      api.rerender('57b12ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemCity/ListItemCity.vue"
export default component.exports